







































































































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import uniq from 'lodash/uniq';

import { STORE_KEY, store } from './_store';
import moment from 'moment';
import ExcelJS from "exceljs";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'items', 'weeks',
    ]),
    ...mapGetters(STORE_KEY, [
      'total'
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX', 'setFilter'
    ])
  },
  components: {
    TitleBar
  }
})
export default class ShipmentForecastByContainer extends Vue {

  get titleStack () {
    return [
      'Прогноз отгрузок по таре'
    ]
  }

  localFilter: any = {
    targetDates: moment().startOf('month').toDate(),
    employee_id: null,
    client_name: null
  }
  opened: any[] = [];

  get defaultSort() {
    return [this.$route.query.sortField || 'client_name', this.$route.query.sortDirection || 'asc']
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.client_id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.client_id != row.client_id)
      );
    }
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  tableToExcel(no_products: boolean = false) {
    this.$store.dispatch(`${STORE_KEY}/exportData`, {...this.localFilter, no_products}).then((csvContent: any[]) => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Отчет')
      csvContent.forEach((row: any, idx: number) => {
        const _row: any = worksheet.addRow(row)
        if (idx == 1) {
          for(let i = 0; i < (row.length - 3)/ 2; i++) {
            worksheet.mergeCells(1, i * 2 + 4, 1, i * 2 + 5);
          }
        }

        _row.eachCell({ includeEmpty: true }, function(cell: any, colNumber: number) {
          
          if (idx < 3) {
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
            cell.style.font = {
              size: 11,
              bold: true
            }
          } else {
            if (colNumber > 1) {
              cell.value = `${cell.value}`.replace('.', ',')
              cell.numFmt = '#,##0.00'
              cell.alignment = { vertical: 'middle', horizontal: 'center' };
            }
          }
        });
      })
      worksheet.columns.map((col: any) => {
        col.width = 15;
      }) 
      workbook.xlsx.writeBuffer()
      .then( function (xls64: any) {
          const a = document.createElement("a");
          const data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          const url = URL.createObjectURL(data);
          a.href = url;
          a.download = "export.xlsx";
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
          },
          0);
      })
      .catch(function(error: any) {
          console.log(error.message);
      });
    })
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.targetDates = (this.$route.query && this.$route.query.targetDates) ? moment(this.$route.query.targetDates).toDate() : moment().startOf('month').toDate();
    // @ts-ignore
    this.localFilter.employee_id = this.$route.query.employee_id;
    // @ts-ignore
    this.localFilter.client_name = this.$route.query.client_name;
    // @ts-ignore
    this.localFilter.client_id = this.$route.query.client_id;
    // @ts-ignore
    this.localFilter.with_archived = this.$route.query.with_archived;

    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = (key == 'targetDates') ? moment(this.localFilter[key]).format('YYYY-MM-DD') : this.localFilter[key]
      return ac;
    }, {});

    this.$router.replace({
      query
    })
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
